module.exports = __webpack_public_path__ + "img/bayar_di_alfa.ee69bad9.jpg";